import CoveragePackageModalLink from '../../CoveragePackageModalLink';
import { NumberField } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { PrhHolidayHomeOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../../utils/coverablesUtil';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { useUpdateCoveragePackageInformation } from '../../../../../recoil/hooks/useUpdateCoveragePackageInformation';
import { prhManualSumIsValid } from '../../../configs/LobPackagesConfig';
import { refreshCoveragePackagePricesAtom } from '../../../../../recoil/atoms/refreshCoveragePackagePricesAtom';
import { roundUpManualSumToNearestThousand } from '../../../../ShoppingBasketPage/utils/ShoppingBasketInsuranceSumsUtil';

const HolidayHomeInputManualSum = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const modalName = getHippoText('DSS-COVERAGE-PACKAGE-PAGE-INPUT-INFO');
    const refreshPrices = useSetRecoilState(refreshCoveragePackagePricesAtom);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { updateCoveragePackageInformation } =
        useUpdateCoveragePackageInformation<PrhHolidayHomeOnsaDTO>();
    const { flavourName = '', fixedId = '' } = useRecoilValue(getOnsaCurrentProductSelector);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as PrhHolidayHomeOnsaDTO;

    const saveManualSum = (): void => {
        if (coverable.contentInsuranceManualSum) {
            setIsLoading(true);
            const roundedUpManualSum = roundUpManualSumToNearestThousand(
                coverable.contentInsuranceManualSum
            );
            updateCoverableInformation({
                contentInsuranceManualSum: roundedUpManualSum
            });
            void updateCoveragePackageInformation({
                contentInsuranceManualSum: roundedUpManualSum
            }).then(() => {
                refreshPrices({});
                setIsLoading(false);
            });
        }
    };

    return (
        <>
            <div className="u-flex-box u-flex-box--space-between">
                <h4>{getHippoText('DSS-COVERAGE-PACKAGE-PAGE-MANUALSUM-HEADER')}</h4>
                <CoveragePackageModalLink
                    modalName={modalName}
                    title={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-MANUALSUM-INFO-HEADER')}
                    description={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-MANUALSUM-INFO-BODY')}
                />
            </div>
            <div className="u-spacing-stack-none">
                <NumberField
                    label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-MANUALSUM-INPUT')}
                    value={coverable.contentInsuranceManualSum}
                    suffix=" kr."
                    withFormatting
                    onChange={(event) => {
                        const number = event.target.value?.split(' ')[0].replaceAll('.', '');
                        updateCoverableInformation({
                            contentInsuranceManualSum: number
                        });
                    }}
                    onBlur={saveManualSum}
                    isValid={prhManualSumIsValid(coverable)}
                    disabled={isLoading}
                    minLength={1}
                />
            </div>
        </>
    );
};

export default HolidayHomeInputManualSum;
